export enum DocumentName {
  CERTIFICATE_OF_OWNERSHIP = 'Certificate of Ownership.pdf',
  PURCHASE_AGREEMENT = 'Purchase Agreement.pdf',
}
